<p>
  {{ 'AUTH.LEAD.DEMO' | translate}}
</p>
